import React from "react";
import { useNavigate } from "react-router-dom";
import TornaAlMenu from "../components/TornaAlMenu";

export default function ArchivioProforme() {
  const nav = useNavigate();

  return (
    <div className="container mt-4">
      <TornaAlMenu to="/" />

      <h2 className="mb-4">🗃️ Archivio proforme</h2>

      <div className="row g-3">
        <div className="col-12 col-md-6">
          <div
            className="card shadow-sm h-100"
            role="button"
            onClick={() => nav("/fatture/archivio?tipo=ricevute")}
          >
            <div className="card-body d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">Archivio</div>
                <div className="fw-bold fs-5">Proforme ricevute dalla Sede →</div>
                <div className="small text-muted mt-1">Storico proforme ricevute, pagate e da pagare.</div>
              </div>
              <div style={{ fontSize: 42 }}>📥</div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6">
          <div
            className="card shadow-sm h-100"
            role="button"
            onClick={() => nav("/fatture/archivio?tipo=emesse")}
          >
            <div className="card-body d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">Archivio</div>
                <div className="fw-bold fs-5">Proforme emesse ai clienti →</div>
                <div className="small text-muted mt-1">Storico proforme emesse, incassate e da incassare.</div>
              </div>
              <div style={{ fontSize: 42 }}>📤</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
